/**
 * Simple Wallet - Luxury Shopify Theme JavaScript
 * Inspired by Louis Vuitton, Gucci, Chanel
 */

(function() {
  'use strict';

  // ========================================
  // Header Scroll Detection
  // ========================================

  function initHeaderScroll() {
    const header = document.querySelector('[data-header]');
    if (!header) return;

    let lastScroll = 0;
    const scrollThreshold = 50;

    function updateHeader() {
      const currentScroll = window.scrollY;

      if (currentScroll > scrollThreshold) {
        header.classList.add('is-scrolled');
      } else {
        header.classList.remove('is-scrolled');
      }

      lastScroll = currentScroll;
    }

    window.addEventListener('scroll', updateHeader, { passive: true });
    updateHeader(); // Initial check
  }

  // ========================================
  // Menu Drawer (Slide from Left)
  // ========================================

  function initMenuDrawer() {
    const menuToggle = document.querySelector('[data-menu-toggle]');
    const menuDrawer = document.querySelector('[data-menu-drawer]');
    const menuOverlay = document.querySelector('[data-menu-overlay]');
    const menuClose = document.querySelector('[data-menu-close]');
    const menuSearchBtn = document.querySelector('[data-menu-search-toggle]');

    if (!menuToggle || !menuDrawer) return;

    function openMenu() {
      menuDrawer.classList.add('is-open');
      if (menuOverlay) menuOverlay.classList.add('is-open');
      document.body.classList.add('menu-open');
    }

    function closeMenu() {
      menuDrawer.classList.remove('is-open');
      if (menuOverlay) menuOverlay.classList.remove('is-open');
      document.body.classList.remove('menu-open');
    }

    menuToggle.addEventListener('click', openMenu);

    if (menuClose) {
      menuClose.addEventListener('click', closeMenu);
    }

    if (menuOverlay) {
      menuOverlay.addEventListener('click', closeMenu);
    }

    // Menu search button - close menu and open search
    if (menuSearchBtn) {
      menuSearchBtn.addEventListener('click', function() {
        closeMenu();
        // Small delay to allow menu to close before opening search
        setTimeout(function() {
          const searchOverlay = document.querySelector('[data-search-overlay]');
          const searchInput = document.querySelector('[data-search-input]');
          if (searchOverlay) {
            searchOverlay.classList.add('is-open');
            document.body.classList.add('search-open');
            if (searchInput) {
              setTimeout(function() {
                searchInput.focus();
              }, 100);
            }
          }
        }, 150);
      });
    }

    // Close on link click
    menuDrawer.querySelectorAll('a').forEach(function(link) {
      link.addEventListener('click', closeMenu);
    });

    // Close on Escape
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && menuDrawer.classList.contains('is-open')) {
        closeMenu();
      }
    });
  }

  // ========================================
  // Contact Sidebar (Slide from Right)
  // ========================================

  function initContactDrawer() {
    const contactToggle = document.querySelector('[data-contact-toggle]');
    const contactDrawer = document.querySelector('[data-contact-drawer]');
    const contactOverlay = document.querySelector('[data-contact-overlay]');
    const contactClose = document.querySelector('[data-contact-close]');

    if (!contactToggle || !contactDrawer) return;

    function openContact() {
      contactDrawer.classList.add('is-open');
      if (contactOverlay) contactOverlay.classList.add('is-open');
      document.body.classList.add('contact-open');
    }

    function closeContact() {
      contactDrawer.classList.remove('is-open');
      if (contactOverlay) contactOverlay.classList.remove('is-open');
      document.body.classList.remove('contact-open');
    }

    contactToggle.addEventListener('click', openContact);

    if (contactClose) {
      contactClose.addEventListener('click', closeContact);
    }

    if (contactOverlay) {
      contactOverlay.addEventListener('click', closeContact);
    }

    // Close on Escape
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && contactDrawer.classList.contains('is-open')) {
        closeContact();
      }
    });
  }

  // ========================================
  // Cart Drawer (Slide from Right)
  // ========================================

  function initCartDrawer() {
    const cartToggle = document.querySelector('[data-cart-toggle]');
    const cartDrawer = document.querySelector('[data-cart-drawer]');
    const cartOverlay = document.querySelector('[data-cart-overlay]');
    const cartSystem = document.querySelector('[data-cart-system]');
    const cartClose = document.querySelectorAll('[data-cart-close]');

    if (!cartToggle || !cartDrawer) return;

    function openCart() {
      // Abrir el sistema completo (incluye panel de recomendaciones)
      if (cartSystem) {
        cartSystem.classList.add('is-open');
      }
      cartDrawer.classList.add('is-open');
      if (cartOverlay) cartOverlay.classList.add('is-open');
      document.body.classList.add('cart-open');
    }

    function closeCart() {
      if (cartSystem) {
        cartSystem.classList.remove('is-open');
      }
      cartDrawer.classList.remove('is-open');
      if (cartOverlay) cartOverlay.classList.remove('is-open');
      document.body.classList.remove('cart-open');
    }

    cartToggle.addEventListener('click', openCart);

    cartClose.forEach(function(btn) {
      btn.addEventListener('click', closeCart);
    });

    if (cartOverlay) {
      cartOverlay.addEventListener('click', closeCart);
    }

    // Close on Escape
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && (cartDrawer.classList.contains('is-open') || (cartSystem && cartSystem.classList.contains('is-open')))) {
        closeCart();
      }
    });
  }

  // ========================================
  // Search Overlay
  // ========================================

  function initSearchOverlay() {
    const searchToggle = document.querySelector('[data-search-toggle]');
    const searchOverlay = document.querySelector('[data-search-overlay]');
    const searchClose = document.querySelector('[data-search-close]');
    const searchInput = document.querySelector('[data-search-input]');

    if (!searchToggle || !searchOverlay) return;

    function openSearch() {
      searchOverlay.classList.add('is-open');
      document.body.classList.add('search-open');
      if (searchInput) {
        setTimeout(function() {
          searchInput.focus();
        }, 100);
      }
    }

    function closeSearch() {
      searchOverlay.classList.remove('is-open');
      document.body.classList.remove('search-open');
    }

    searchToggle.addEventListener('click', openSearch);

    if (searchClose) {
      searchClose.addEventListener('click', closeSearch);
    }

    // Close on Escape
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && searchOverlay.classList.contains('is-open')) {
        closeSearch();
      }
    });
  }

  // ========================================
  // Hero Carousel
  // ========================================

  function initHeroCarousel() {
    const carousel = document.querySelector('[data-hero-carousel]');
    if (!carousel) return;

    const slides = carousel.querySelectorAll('[data-slide]');
    const dots = carousel.querySelectorAll('[data-carousel-dot]');
    const prevBtn = carousel.querySelector('[data-carousel-prev]');
    const nextBtn = carousel.querySelector('[data-carousel-next]');

    if (slides.length <= 1) return;

    let currentSlide = 0;
    let autoplayInterval;
    const autoplayDelay = 8000;

    function goToSlide(index) {
      slides.forEach(function(slide) {
        slide.classList.remove('is-active');
      });
      dots.forEach(function(dot) {
        dot.classList.remove('is-active');
      });

      currentSlide = index;
      if (currentSlide >= slides.length) currentSlide = 0;
      if (currentSlide < 0) currentSlide = slides.length - 1;

      slides[currentSlide].classList.add('is-active');
      if (dots[currentSlide]) {
        dots[currentSlide].classList.add('is-active');
      }
    }

    function nextSlide() {
      goToSlide(currentSlide + 1);
    }

    function prevSlide() {
      goToSlide(currentSlide - 1);
    }

    function startAutoplay() {
      autoplayInterval = setInterval(nextSlide, autoplayDelay);
    }

    function stopAutoplay() {
      clearInterval(autoplayInterval);
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', function() {
        stopAutoplay();
        nextSlide();
        startAutoplay();
      });
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', function() {
        stopAutoplay();
        prevSlide();
        startAutoplay();
      });
    }

    dots.forEach(function(dot, index) {
      dot.addEventListener('click', function() {
        stopAutoplay();
        goToSlide(index);
        startAutoplay();
      });
    });

    carousel.addEventListener('mouseenter', stopAutoplay);
    carousel.addEventListener('mouseleave', startAutoplay);

    startAutoplay();
  }

  // ========================================
  // Product Form (Cantidad)
  // ========================================

  function initProductForms() {
    // Quantity controls for product page
    const quantityInputs = document.querySelectorAll('[data-quantity-input]');

    // Get max from the form input (the one with name="quantity")
    function getProductMax() {
      const formInput = document.querySelector('input[name="quantity"][data-quantity-input]');
      return formInput ? (parseInt(formInput.max) || 99) : 99;
    }

    // Function to sync all product quantity inputs
    function syncQuantityInputs(newValue) {
      document.querySelectorAll('.product-page__quantity [data-quantity-input]').forEach(function(inp) {
        inp.value = newValue;
      });
    }

    quantityInputs.forEach(function(input) {
      const container = input.closest('.product-page__quantity, .cart-item__quantity');
      if (!container) return;

      // Check if already initialized to prevent duplicate handlers
      if (container.dataset.initialized) return;
      container.dataset.initialized = 'true';

      const minusBtn = container.querySelector('[data-quantity-minus]');
      const plusBtn = container.querySelector('[data-quantity-plus]');
      const isProductPage = container.closest('.product-page__quantity');

      if (minusBtn) {
        minusBtn.addEventListener('click', function() {
          const value = parseInt(input.value) || 1;
          if (value > 1) {
            const newVal = value - 1;
            input.value = newVal;
            if (isProductPage) syncQuantityInputs(newVal);
          }
        });
      }

      if (plusBtn) {
        plusBtn.addEventListener('click', function() {
          const value = parseInt(input.value) || 1;
          const max = isProductPage ? getProductMax() : (parseInt(input.max) || 99);
          if (value < max) {
            const newVal = value + 1;
            input.value = newVal;
            if (isProductPage) syncQuantityInputs(newVal);
          }
        });
      }
    });
  }

  // ========================================
  // Currency Format Helper
  // ========================================

  function formatMoney(cents, currency) {
    var amount = (cents / 100).toFixed(2);
    currency = currency || (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'USD';

    if (currency === 'CRC') {
      return '₡' + amount.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    }
    return '$' + amount;
  }

  // ========================================
  // Ajax Cart
  // ========================================

  function initAjaxCart() {
    const addToCartForms = document.querySelectorAll('[data-product-form]');

    addToCartForms.forEach(function(form) {
      form.addEventListener('submit', function(e) {
        e.preventDefault();

        const formData = new FormData(form);
        const submitBtn = form.querySelector('[type="submit"]');
        const originalText = submitBtn.innerHTML;

        submitBtn.innerHTML = 'Agregando...';
        submitBtn.disabled = true;

        fetch('/cart/add.js', {
          method: 'POST',
          body: formData
        })
        .then(function(response) {
          return response.json();
        })
        .then(function(data) {
          submitBtn.innerHTML = 'Agregado';
          updateCartCount();
          updateCartDrawer();

          // Open cart drawer
          const cartDrawer = document.querySelector('[data-cart-drawer]');
          const cartOverlay = document.querySelector('[data-cart-overlay]');
          if (cartDrawer) {
            cartDrawer.classList.add('is-open');
            if (cartOverlay) cartOverlay.classList.add('is-open');
            document.body.classList.add('cart-open');
          }

          setTimeout(function() {
            submitBtn.innerHTML = originalText;
            submitBtn.disabled = false;
          }, 2000);
        })
        .catch(function(error) {
          console.error('Error:', error);
          submitBtn.innerHTML = 'Error';

          setTimeout(function() {
            submitBtn.innerHTML = originalText;
            submitBtn.disabled = false;
          }, 2000);
        });
      });
    });
  }

  function updateCartCount() {
    fetch('/cart.js')
      .then(function(response) {
        return response.json();
      })
      .then(function(cart) {
        const cartCounts = document.querySelectorAll('.header__cart-count');
        cartCounts.forEach(function(el) {
          if (cart.item_count > 0) {
            el.textContent = cart.item_count;
            el.style.display = 'flex';
          } else {
            el.style.display = 'none';
          }
        });

        // Update cart drawer title
        const cartTitle = document.querySelector('.cart-drawer__title');
        if (cartTitle) {
          cartTitle.textContent = 'Bolsa de Compra (' + cart.item_count + ')';
        }
      });
  }

  function updateCartDrawer() {
    // Usar Section Rendering API para obtener el drawer completo con upsells
    fetch(window.location.pathname + '?sections=header')
      .then(function(response) {
        return response.json();
      })
      .then(function(sections) {
        var parser = new DOMParser();
        var doc = parser.parseFromString(sections.header, 'text/html');

        // Actualizar contenido del drawer (incluye items, upsells, footer)
        var newContent = doc.querySelector('.cart-drawer__content');
        var currentContent = document.querySelector('.cart-drawer__content');
        if (newContent && currentContent) {
          currentContent.innerHTML = newContent.innerHTML;
        }

        // Actualizar título con conteo
        var newTitle = doc.querySelector('.cart-drawer__title');
        var currentTitle = document.querySelector('.cart-drawer__title');
        if (newTitle && currentTitle) {
          currentTitle.textContent = newTitle.textContent;
        }

        // Actualizar panel de recomendaciones (Desktop)
        var newRecPanel = doc.querySelector('.cart-recommendations-panel__content');
        var currentRecPanel = document.querySelector('.cart-recommendations-panel__content');
        if (newRecPanel && currentRecPanel) {
          currentRecPanel.innerHTML = newRecPanel.innerHTML;
        }

        // Manejar visibilidad del panel según estado del carrito
        var newRecPanelContainer = doc.querySelector('.cart-recommendations-panel');
        var currentRecPanelContainer = document.querySelector('.cart-recommendations-panel');
        if (!newRecPanelContainer && currentRecPanelContainer) {
          // Carrito quedó vacío, ocultar panel
          currentRecPanelContainer.style.display = 'none';
        } else if (newRecPanelContainer && currentRecPanelContainer) {
          currentRecPanelContainer.style.display = '';
        }

        // Actualizar shipping bar
        var newShippingBar = doc.querySelector('[data-cart-drawer] .shipping-bar');
        var currentShippingBar = document.querySelector('[data-cart-drawer] .shipping-bar');
        if (newShippingBar && currentShippingBar) {
          currentShippingBar.outerHTML = newShippingBar.outerHTML;
        } else if (newShippingBar) {
          var drawerHeader = document.querySelector('.cart-drawer__header');
          if (drawerHeader) {
            drawerHeader.insertAdjacentHTML('afterend', newShippingBar.outerHTML);
          }
        }

        // Actualizar shipping bar valor
        fetch('/cart.js')
          .then(function(r) { return r.json(); })
          .then(function(cart) {
            updateShippingBar(cart.total_price);
          });
      });
  }

  // ========================================
  // Cart Summary Collapsible Sections
  // ========================================

  function initCartSections() {
    const sections = document.querySelectorAll('[data-cart-section]');

    sections.forEach(function(section) {
      const header = section.querySelector('[data-cart-section-header]');

      if (header) {
        header.addEventListener('click', function() {
          section.classList.toggle('is-open');
        });
      }
    });
  }

  // ========================================
  // Smooth Scroll
  // ========================================

  function initSmoothScroll() {
    document.querySelectorAll('a[href^="#"]').forEach(function(anchor) {
      anchor.addEventListener('click', function(e) {
        const target = document.querySelector(this.getAttribute('href'));
        if (target) {
          e.preventDefault();
          target.scrollIntoView({
            behavior: 'smooth'
          });
        }
      });
    });
  }

  // ========================================
  // Recommendations Carousel
  // ========================================

  function initRecommendationsCarousel() {
    const carousel = document.querySelector('[data-rec-carousel]');
    const prevBtn = document.querySelector('[data-rec-prev]');
    const nextBtn = document.querySelector('[data-rec-next]');

    if (!carousel) return;

    const scrollAmount = 280;
    let autoScrollInterval;
    const autoScrollDelay = 4000; // 4 seconds

    function autoScroll() {
      const maxScroll = carousel.scrollWidth - carousel.clientWidth;
      if (carousel.scrollLeft >= maxScroll - 10) {
        carousel.scrollTo({ left: 0, behavior: 'smooth' });
      } else {
        carousel.scrollBy({ left: scrollAmount, behavior: 'smooth' });
      }
    }

    function startAutoScroll() {
      autoScrollInterval = setInterval(autoScroll, autoScrollDelay);
    }

    function stopAutoScroll() {
      clearInterval(autoScrollInterval);
    }

    // Start auto-scroll
    startAutoScroll();

    // Pause on hover
    carousel.addEventListener('mouseenter', stopAutoScroll);
    carousel.addEventListener('mouseleave', startAutoScroll);

    // Pause on touch
    carousel.addEventListener('touchstart', stopAutoScroll);
    carousel.addEventListener('touchend', function() {
      setTimeout(startAutoScroll, 2000);
    });

    if (prevBtn) {
      prevBtn.addEventListener('click', function() {
        stopAutoScroll();
        carousel.scrollBy({ left: -scrollAmount, behavior: 'smooth' });
        setTimeout(startAutoScroll, 3000);
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', function() {
        stopAutoScroll();
        carousel.scrollBy({ left: scrollAmount, behavior: 'smooth' });
        setTimeout(startAutoScroll, 3000);
      });
    }
  }

  // ========================================
  // Promo Modal
  // ========================================

  function initPromoModal() {
    // Check if already shown this session
    if (sessionStorage.getItem('promoModalShown')) return;

    // Check if collections data exists
    if (!window.promoCollections || window.promoCollections.length === 0) return;

    const overlay = document.querySelector('[data-promo-modal]');
    const closeBtn = document.querySelector('[data-promo-close]');
    const link = document.querySelector('[data-promo-link]');
    const imageEl = document.querySelector('[data-promo-image]');
    const titleEl = document.querySelector('[data-promo-title]');
    const subtitleEl = document.querySelector('[data-promo-subtitle]');

    if (!overlay || !imageEl || !titleEl) return;

    // Select random collection
    const randomIndex = Math.floor(Math.random() * window.promoCollections.length);
    const collection = window.promoCollections[randomIndex];

    // Populate modal
    imageEl.style.backgroundImage = `url(${collection.image})`;
    titleEl.textContent = collection.title;
    if (subtitleEl && collection.subtitle) {
      subtitleEl.textContent = collection.subtitle;
    }
    link.href = collection.url;

    // Show modal after delay
    setTimeout(function() {
      overlay.classList.add('active');
      document.body.style.overflow = 'hidden';
    }, 1500);

    // Close handlers
    function closeModal() {
      overlay.classList.remove('active');
      document.body.style.overflow = '';
      sessionStorage.setItem('promoModalShown', 'true');
    }

    closeBtn.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();
      closeModal();
    });

    overlay.addEventListener('click', function(e) {
      if (e.target === overlay) {
        closeModal();
      }
    });

    // Close on Escape key
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && overlay.classList.contains('active')) {
        closeModal();
      }
    });
  }

  // ========================================
  // Product Card Image Gallery (Hover Navigation)
  // ========================================

  function initProductCardGallery() {
    var productCards = document.querySelectorAll('[data-product-card]');

    productCards.forEach(function(card) {
      var images = card.querySelectorAll('.product-card__image');
      var dots = card.querySelectorAll('.product-card__dot');
      var prevBtn = card.querySelector('[data-nav="prev"]');
      var nextBtn = card.querySelector('[data-nav="next"]');

      if (images.length <= 1) return;

      var currentIndex = 0;

      function showImage(index) {
        if (index >= images.length) index = 0;
        if (index < 0) index = images.length - 1;
        currentIndex = index;

        images.forEach(function(img, i) {
          img.classList.toggle('is-active', i === currentIndex);
        });

        dots.forEach(function(dot, i) {
          dot.classList.toggle('is-active', i === currentIndex);
        });
      }

      if (prevBtn) {
        prevBtn.addEventListener('click', function(e) {
          e.preventDefault();
          e.stopPropagation();
          showImage(currentIndex - 1);
        });
      }

      if (nextBtn) {
        nextBtn.addEventListener('click', function(e) {
          e.preventDefault();
          e.stopPropagation();
          showImage(currentIndex + 1);
        });
      }

      // Click on dots
      dots.forEach(function(dot, i) {
        dot.addEventListener('click', function(e) {
          e.preventDefault();
          e.stopPropagation();
          showImage(i);
        });
      });
    });
  }

  // ========================================
  // Scroll to Top Button
  // ========================================

  function initScrollToTop() {
    const scrollBtn = document.querySelector('[data-scroll-top]');
    if (!scrollBtn) return;

    function toggleButton() {
      if (window.scrollY > 3500) {
        scrollBtn.classList.add('visible');
      } else {
        scrollBtn.classList.remove('visible');
      }
    }

    window.addEventListener('scroll', toggleButton, { passive: true });

    scrollBtn.addEventListener('click', function() {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    });
  }

  // ========================================
  // Text Banner Carousel
  // ========================================

  function initTextBanner() {
    const banner = document.querySelector('[data-text-banner]');
    if (!banner) return;

    const slides = banner.querySelectorAll('.text-banner__slide');
    const prevBtn = banner.querySelector('[data-banner-prev]');
    const nextBtn = banner.querySelector('[data-banner-next]');
    let currentIndex = 0;
    let autoSlideInterval;

    function showSlide(index) {
      slides.forEach(function(s) { s.classList.remove('is-active'); });
      currentIndex = (index + slides.length) % slides.length;
      slides[currentIndex].classList.add('is-active');
    }

    function nextSlide() {
      showSlide(currentIndex + 1);
    }

    function prevSlide() {
      showSlide(currentIndex - 1);
    }

    function startAutoSlide() {
      autoSlideInterval = setInterval(nextSlide, 7000);
    }

    function resetAutoSlide() {
      clearInterval(autoSlideInterval);
      startAutoSlide();
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', function() { prevSlide(); resetAutoSlide(); });
    }
    if (nextBtn) {
      nextBtn.addEventListener('click', function() { nextSlide(); resetAutoSlide(); });
    }

    startAutoSlide();
  }

  // ========================================
  // Personalization Checkbox (Simplified)
  // ========================================

  function initPersonalizationCheckbox() {
    const checkbox = document.querySelector('[data-personalize-checkbox]');
    const note = document.querySelector('[data-personalize-note]');

    if (!checkbox || !note) return;

    // Show/hide note when checkbox changes
    checkbox.addEventListener('change', function() {
      note.style.display = this.checked ? 'block' : 'none';
    });
  }

  // ========================================
  // Free Shipping Bar - Dynamic Updates
  // ========================================

  function updateShippingBar(cartTotal) {
    var bars = document.querySelectorAll('[data-shipping-bar]');
    if (!bars.length) return;

    bars.forEach(function(bar) {
      var threshold = parseInt(bar.dataset.threshold) || 4500;
      var remaining = threshold - cartTotal;
      var progress = Math.min((cartTotal / threshold) * 100, 100);

      var progressEl = bar.querySelector('[data-shipping-progress]');
      var messageEl = bar.querySelector('[data-shipping-message]');

      if (progressEl) {
        progressEl.style.width = progress + '%';
      }

      if (remaining > 0) {
        bar.classList.remove('shipping-bar--complete');
        if (messageEl) {
          var currency = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'USD';
          messageEl.innerHTML =
            '<span class="shipping-bar__icon">' +
              '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5">' +
                '<path d="M1 3h15v13H1z"/>' +
                '<path d="M16 8h4l3 3v5h-7V8z"/>' +
                '<circle cx="5.5" cy="18.5" r="2.5"/>' +
                '<circle cx="18.5" cy="18.5" r="2.5"/>' +
              '</svg>' +
            '</span>' +
            '<span>Agrega <strong data-remaining-amount>' + formatMoney(remaining, currency) + '</strong> más para <strong>envio GRATIS!</strong></span>';
        }
      } else {
        bar.classList.add('shipping-bar--complete');
        if (messageEl) {
          messageEl.innerHTML =
            '<span class="shipping-bar__icon">' +
              '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5">' +
                '<path d="M20 6L9 17l-5-5"/>' +
              '</svg>' +
            '</span>' +
            '<span><strong>Felicidades!</strong> Tienes envio GRATIS</span>';
        }
      }
    });
  }

  // ========================================
  // Cart Upsell - Quick Add
  // ========================================

  function initCartUpsells() {
    document.addEventListener('click', function(e) {
      var upsellBtn = e.target.closest('[data-upsell-add]');
      if (!upsellBtn) return;

      var variantId = upsellBtn.dataset.upsellAdd;
      var textEl = upsellBtn.querySelector('.cart-rec-item__add-text');
      var checkEl = upsellBtn.querySelector('.cart-rec-item__add-check');

      // Mostrar loading
      if (textEl) {
        textEl.textContent = '...';
      } else {
        upsellBtn.textContent = '...';
      }
      upsellBtn.disabled = true;

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: parseInt(variantId), quantity: 1 })
      })
      .then(function(response) {
        return response.json();
      })
      .then(function() {
        // Mostrar checkmark de éxito
        upsellBtn.classList.add('cart-rec-item__add--added');
        upsellBtn.classList.add('cart-upsells-scroll__add--added');

        if (textEl) {
          textEl.style.display = 'none';
        }
        if (checkEl) {
          checkEl.style.display = 'flex';
        }
        if (!textEl && !checkEl) {
          upsellBtn.textContent = 'Agregado';
        }

        updateCartCount();
        updateCartDrawer();

        // Update shipping bar
        fetch('/cart.js')
          .then(function(r) { return r.json(); })
          .then(function(cart) {
            updateShippingBar(cart.total_price);
          });

        // Reset después de 2 segundos
        setTimeout(function() {
          upsellBtn.classList.remove('cart-rec-item__add--added');
          upsellBtn.classList.remove('cart-upsells-scroll__add--added');

          if (textEl) {
            textEl.textContent = 'Agregar';
            textEl.style.display = '';
          }
          if (checkEl) {
            checkEl.style.display = 'none';
          }
          if (!textEl && !checkEl) {
            upsellBtn.textContent = 'Agregar';
          }
          upsellBtn.disabled = false;
        }, 2000);
      })
      .catch(function() {
        if (textEl) {
          textEl.textContent = 'Agregar';
          textEl.style.display = '';
        } else {
          upsellBtn.textContent = 'Agregar';
        }
        if (checkEl) {
          checkEl.style.display = 'none';
        }
        upsellBtn.disabled = false;
      });
    });
  }

  // ========================================
  // Initialization
  // ========================================

  function init() {
    initHeaderScroll();
    initMenuDrawer();
    initContactDrawer();
    initCartDrawer();
    initSearchOverlay();
    initHeroCarousel();
    initProductForms();
    initAjaxCart();
    initCartSections();
    initSmoothScroll();
    initRecommendationsCarousel();
    initPromoModal();
    initProductCardGallery();
    initScrollToTop();
    initTextBanner();
    initPersonalizationCheckbox();
    initCartUpsells();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
